<template>
  <div class="ExpertThinkTank">
    <PageBanner :bannerObj="bannerObj"></PageBanner>
    <div class="cont wow bounceInUp">
      <!-- <div class="box_class">
        <div class="b_title">专家分类</div>
        <ul class="classList">
          <li class="classItem cur">全部</li>
          <li class="classItem">某某方向</li>
          <li class="classItem">某某方向</li>
          <li class="classItem">某某方向</li>
          <li class="classItem">某某方向</li>
          <li class="classItem">某某方向</li>
          <li class="classItem">某某方向</li>
        </ul>
      </div> -->
      <div class="expertList">
        <div class="expertItem" v-for="(item, index) in resList" :key="index">
          <div class="name">{{ item.name }}</div>
          <div class="address">
            <div class="i_lable">所在单位:</div>
            <div class="i_value">
              <el-tooltip placement="top">
                <div slot="content">
                  <div class="c_titleTips">
                    {{ item.unit }}
                  </div>
                </div>
                <span class="value1">{{ item.unit }}</span>
              </el-tooltip>

              <span class="value2">{{ item.post }}</span>
            </div>
          </div>
          <div class="direction">
            <div class="i_lable">研究方向:</div>
            <el-tooltip placement="top">
              <div slot="content">
                <div class="c_titleTips">
                  {{ item.direction }}
                </div>
              </div>
              <div class="i_value">{{ item.direction }}</div>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="box_pagination">
        <el-pagination background layout="prev, pager, next" :hide-on-single-page="resList.length <= companyPageSize"
                       :page-size="companyPageSize" :total="companyTotal" @size-change="getCompanyPage"
                       @current-change="getCompanyPage">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import PageBanner from "@/components/common/pageBanner"
export default {
  name: "ExpertThinkTank",
  metaInfo () {
    return {
      title: "专家智库",
      meta: [
        { name: "keywords", content: "广州统计师事务所" },
        { name: "description", content: "广州统计师事务所" },
      ],
    }
  },
  data () {
    return {
      resList: [],
      companyTotal: 27, // 总数
      companyPageNo: 1, // 当前页
      companyPageSize: 12, // 每页显示条数
      bannerObj: {
        lableZh: "专家智库",
        lableEn: "EXPERTS THINK TANK",
        bannerImg: require("@/assets/img/expertThinkTank/banner.jpg"),
      },
      expertList: [
        [
          {
            name: "李超海",
            unit: "广东省社会科学院",
            post: "副研究员",
            direction: "经济社会学、农民工和社会治理",
          },
          {
            name: "刘照德",
            unit: "广东财经大学",
            post: "副教授",
            direction: "经济统计分析、转型升级、高新技术等",
          },
          {
            name: "张仁寿",
            unit: "广州大学",
            post: "教授",
            direction: "经济统计、产业政策研究",
          },
          {
            name: "杨扬",
            unit: "中山大学国际金融学院",
            post: "副教授",
            direction: "产业与企业经济学，区域经济学，经济增长理论",
          },
          {
            name: "黄晓凤",
            unit: "广东财经大学",
            post: "教授",
            direction: "国民经济学、国际经济学、经济统计",
          },
          {
            name: "孙红英",
            unit: "广东财经大学",
            post: "副教授",
            direction: "经济统计分析，经济管理问题中的数学建模",
          },
          {
            name: "张青",
            unit: "中共广东省委党校",
            post: "教授、院长、博导",
            direction: "经济统计",
          },
          {
            name: "韩兆洲",
            unit: "暨南大学 ",
            post: "教授、院长、博导",
            direction: "经济统计",
          },
          {
            name: "黄玉",
            unit: "市社科院 ",
            post: "所长 ",
            direction: "社会学与社会政策研究",
          },
          {
            name: "田向东",
            unit: "广东金融学院公共管理学院",
            post: "教授 ",
            direction: "人力资源与社会保障、社会资本、职业流动、战略管理",
          },
          {
            name: "伍业锋",
            unit: "暨南大学经济学院",
            post: "副教授",
            direction: "经济统计、统计调查和海洋经济",
          },
          {
            name: "阳义南",
            unit: "华南理工大学",
            post: "教授",
            direction: "老年社会保障、老年经济学、社会保、劳动就业",
          },
        ],
        [
          {
            name: "揭昊",
            unit: "广州市社会科学院现代市场研究所",
            post: "高级经济师",
            direction: "商务政策研究",
          },
          {
            name: "朱泯静",
            unit: "广州市社会科学院社会学与社会政策研究所",
            post: "副研究员",
            direction: "社会政策、公共服务、产业经济、营商环境、企业创新",
          },
          {
            name: "余壮雄",
            unit: "暨南大学产业经济研究院 ",
            post: "研究员",
            direction: "产业政策、国际贸易和区域发展",
          },
          {
            name: "李景海",
            unit: "暨南大学产业经广东财经大学国民经济研究中心济研究院 ",
            post: "教授",
            direction: "产业经济研究",
          },
          {
            name: "施颖",
            unit: "广东财经大学经济学院",
            post: "讲师",
            direction: "工业经济和发展经济学研究",
          },
          {
            name: "杨海水",
            unit: "广东财经大学经济学院",
            post: "讲师",
            direction: "民营经济研究、制度经济学",
          },
          {
            name: "陈耕云",
            unit: "广东金融学院金融数学与统计学院  ",
            post: "副教授，高级统计师",
            direction: "人口统计及金融市场与投资",
          },
          {
            name: "林湘华",
            unit: "中山大学南方学院  ",
            post: "讲师",
            direction: "人口与社会、人口老龄化、农村人口研究",
          },
          {
            name: "李晓莉",
            unit: "广东外语外贸大学  ",
            post: "助理研究员",
            direction: "产业经济与区域经济研究",
          },
          {
            name: "陈杰",
            unit: "广州市社会科学院社会学与社会政策研究所  ",
            post: "副研究员",
            direction: "社会治理、社会政策",
          },
          {
            name: "王首燕",
            unit: "广州市社会科学院社会学与社会政策研究所  ",
            post: "副研究员",
            direction: "公共服务与社会转型研究",
          },
          {
            name: "简荣",
            unit: "广州市社会科学院社会学与社会政策研究所  ",
            post: "会长",
            direction: "公共服务 社会调查",
          },
        ],
        [
          {
            name: "陈火君",
            unit: "华南农业大学资源环境学院",
            post: "高级农艺师",
            direction: "农作物种植、农业资源利用",
          },
          {
            name: "黎华寿",
            unit: "华南农业大学",
            post: "教授",
            direction: "农业经济",
          },
          {
            name: "李文波",
            unit: "广州市轨道交通产业联盟",
            post: "副秘书长",
            direction: "轨道交通产业研究",
          },
        ],
      ],
    }
  },
  created () {
    this.resList = this.expertList[0]
  },
  mounted () {
    // 在项目加载完成之后初始化wow
    new this.$wow({
      //默认为true
      live: false,
    }).init()
  },
  methods: {
    async getCompanyPage (page) {
      // 获取第 page 页数据
      // console.log(page-1);
      this.companyPageNo = page
      this.resList = this.expertList[page - 1]
      // this.getInfoManageList();
    },
  },
  components: {
    PageBanner,
  },
};
</script>
<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.ExpertThinkTank {
  width: 100%;
  min-width: $themeMinWidth;
  box-sizing: border-box;
  padding: 0 0 50px 0;
  .cont {
    width: $themeMinWidth;
    margin: 0 auto;
    padding: 40px 0 0 0;
    .box_class {
      display: flex;
      min-height: 30px;
      line-height: 30px;
      background-color: #f9f9f9;
      padding: 10px 30px 0;
      .b_title {
        flex-shrink: 0;
        width: 120px;
        font-size: 18px;
        font-weight: bold;
        color: #406cdd;
      }
      .classList {
        width: 1000px;
        min-height: 40px;
        overflow: auto;
        white-space: nowrap;
        .classItem {
          display: inline-block;
          min-width: 64px;
          height: 30px;
          line-height: 30px;
          padding: 0 30px;
          border-radius: 5px;
          cursor: pointer;
          font-size: 16px;
          color: #333333;
          margin: 0 0 10px 10px;
          transition: 0.4s;
          text-align: center;
          &.cur,
          &:hover {
            background-color: #406cdd;
            color: #ffffff;
          }
        }
      }
    }
    .expertList {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 30px 0 0 0;
      .expertItem {
        width: 365px;
        height: 230px;
        margin: 0 0 30px 0;
        box-sizing: border-box;
        padding: 20px;
        background: #fafafa url("../assets/img/expertThinkTank/bg.png")
          no-repeat;
        background-size: 100% 100%;
        .name {
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: bold;
          line-height: 24px;
          color: #406cdd;
          padding: 0 0 20px 0;
          position: relative;
          &::before {
            content: "";
            display: block;
            width: 30px;
            height: 30px;
            margin: 0 6px 0 0;
            background: #fafafa
              url("../assets/img/expertThinkTank/icon_name.png") no-repeat;
            background-size: 100% 100%;
          }
        }
        .address {
          padding: 0 0 10px 36px;
          position: relative;
          &::before {
            content: "";
            display: inline-block;
            width: 30px;
            height: 30px;
            background: #fafafa
              url("../assets/img/expertThinkTank/icon_address.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
          .i_lable {
            line-height: 30px;
            font-size: 18px;
            color: #333333;
          }
          .i_value {
            font-size: 16px;
            line-height: 30px;
            color: #666666;
            display: flex;
            .value1 {
              margin: 0 30px 0 0;
              width: 128px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
            }
            .value2 {
            }
          }
        }
        .direction {
          padding: 0 0 0 36px;
          position: relative;
          &::before {
            content: "";
            display: inline-block;
            width: 30px;
            height: 30px;
            background: #fafafa
              url("../assets/img/expertThinkTank/icon_direction.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
          .i_lable {
            line-height: 30px;
          }
          .i_value {
            font-size: 16px;
            line-height: 30px;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
    .box_pagination {
      text-align: center;
      /deep/ .el-pager .number.active {
        background-color: #406cdd;
      }
    }
  }
}
</style>
